// import Swiper JS
import Swiper from "swiper";
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Lazy } from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Lazy]);

// import Swiper styles
import "swiper/swiper-bundle.css";

const swiper = $(document).ready(function () {
    let swiper0Opts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        autoResize: false,
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        watchOverflow: true,
    };

    var swiper0 = new Swiper(".swiper-container.swiper0", swiper0Opts);

    let swiper4Opts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        observeParents: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 3,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 5,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next.swiper4",
            prevEl: ".swiper-button-prev.swiper4",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper4",
            draggable: true,
        },
    };

    let swiper4 = new Swiper(".swiper-container.swiper4", swiper4Opts);
});

export { swiper as default };
